import {
  Wrapper,
  InnerWrapper,
  Bars,
  Bar,
  TextOverlay,
  FoneImageLeft,
  FoneImageRight,
} from "./LogoAnimatedStyles";

import FoneLeft from "../../img/logo/foneLeft.svg";
import FoneRight from "../../img/logo/foneRight.svg";
import { useEffect, useState } from "react";

export default function LogoAnimated() {
  const [barCount, setBarCount] = useState(25);

  useEffect(() => {
    const isDesktop = window.innerWidth >= 1025;
    setBarCount(isDesktop ? 35 : 25);
  }, []);

  const mid = barCount / 2;
  const maxHeight = 90;

  return (
    <Wrapper>
      <FoneImageLeft>
        <img src={FoneLeft} alt="Fone esquerdo" />
      </FoneImageLeft>

      <InnerWrapper>
        <Bars>
          {Array.from({ length: barCount }).map((_, index) => {
            const distance = Math.abs(index - mid + 0.5);
            const height = maxHeight - distance * 5.5;
            return (
              <Bar key={index} delay={(index % 6) * 0.1} height={height} />
            );
          })}
        </Bars>
        <TextOverlay>
          <span>Press</span> Kit
        </TextOverlay>
      </InnerWrapper>

      <FoneImageRight>
        <img src={FoneRight} alt="Fone direito" />
      </FoneImageRight>
    </Wrapper>
  );
}
